import React, { useState } from 'react';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import Text from '../../../../../Components/Base/Text/Text';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
// @ts-ignore
import styles from './CaseTypeList.module.scss';
import CaseTypeDetailModal from '../Detail/CaseTypeDetailModal';
import CaseTypeOrganizationUnitModal from '../OrganizationUnit/CaseTypeOrganizationUnitModal';
import CaseTypeListHeader from '../ListHeader/CaseTypeListHeader';

interface Props {
	workplaceId: string;
}

const WRAPPER_ID = 'caseTypeListWrapper';

const CaseTypeList: React.FC<Props> = ({ workplaceId }) => {
	const [caseTypeId, setCaseTypeId] = useState<string | undefined>(undefined);
	const [organizationUnitId, setOrganizationUnitId] = useState<
		string | undefined
	>(undefined);
	const [isCaseTypeDetailOpen, setIsCaseTypeDetailOpen] = useState(false);
	const [isOrganizationUnitDetailOpen, setIsOrganizationUnitTypeDetailOpen] =
		useState(false);

	const handleCreateCaseType = () => {
		setIsCaseTypeDetailOpen(true);
	};

	const handleEditCaseType = (id: string) => {
		setCaseTypeId(id);
		setIsCaseTypeDetailOpen(true);
	};

	const handleCreateOrganizationUnit = () => {
		setIsOrganizationUnitTypeDetailOpen(true);
	};

	const handleEditOrganizationUnit = (id: string) => {
		setOrganizationUnitId(id);
		setIsCaseTypeDetailOpen(true);
	};

	return (
		<div className={styles.wrapper}>
			<CaseTypeListHeader workplaceId={workplaceId} />
			<ScrollContainer wrapperId={WRAPPER_ID}>
				<></>
			</ScrollContainer>
		</div>
	);
};

export default CaseTypeList;
